/**
 * External Dependencies
 */
import 'jquery';
import Swiper, { Autoplay, FreeMode, EffectFade } from 'swiper';
import simpleParallax from 'simple-parallax-js';
import resolveConfig from 'tailwindcss/resolveConfig';
import tailwindConfig from '../../tailwind.config';
import { initMap } from './acf-map';

const twConfig = resolveConfig(tailwindConfig);

$(() => {
  // console.log(config);
  var slidingDoor = $('.sliding-door');
  if (slidingDoor) {
    setTimeout(() => {
      slidingDoor.addClass('--open');
    }, 2000);
  }

  /**
   * Hero slider
   */
  const heroSelector = '.hero';
  const heroslideCount = $(heroSelector + ' .swiper-slide').length;
  const multipleHeroSlides = heroslideCount > 1;

  const HERO_SLIDER_SPEED = 7000;
  const heroSlider = new Swiper('.hero', {
    loop: multipleHeroSlides,
    autoplay: multipleHeroSlides,
    speed: HERO_SLIDER_SPEED,
    mousewheel: false,
    pagination: false,
    navigation: false,
    watchOverflow: !multipleHeroSlides,
    effect: multipleHeroSlides ? 'fade' : 'slide',
    modules: multipleHeroSlides ? [Autoplay, EffectFade] : null,
  });

  /**
   * Case study preview slider
   */
  const caseStudyPreviewsSliderSelector = '.case-study-previews';
  const CASE_STUDY_SLIDER_SPEED = 5000;

  const CASE_STUDY_SLIDER_SLIDES_PER_VIEW_MD = 2;
  const CASE_STUDY_SLIDER_SLIDES_PER_VIEW_LG = 3;

  const currentSPV = () => {
    if (window.matchMedia('(min-width: ' + twConfig.theme.screens.lg + ')').matches) {
      return CASE_STUDY_SLIDER_SLIDES_PER_VIEW_LG;
    } else if (window.matchMedia('(min-width: ' + twConfig.theme.screens.md + ')').matches) {
      return CASE_STUDY_SLIDER_SLIDES_PER_VIEW_MD;
    } else {
      return 1;
    }
  }

  const caseStudyPreviewsSlider = new Swiper(caseStudyPreviewsSliderSelector, {
    loop: true,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    speed: CASE_STUDY_SLIDER_SPEED,
    grabCursor: true,
    mousewheel: false,
    pagination: false,
    navigation: false,
    modules: [Autoplay],
    breakpoints: {
      [parseFloat(twConfig.theme.screens.md)]: {
        slidesPerView: CASE_STUDY_SLIDER_SLIDES_PER_VIEW_MD,
      },
      [parseFloat(twConfig.theme.screens.lg)]: {
        slidesPerView: CASE_STUDY_SLIDER_SLIDES_PER_VIEW_LG,
      },
    },
  });

  $(caseStudyPreviewsSliderSelector).on('mouseenter', () => {
    let toX = caseStudyPreviewsSlider.translate;
    let fromX = toX + caseStudyPreviewsSlider.width / currentSPV();
    let currentX = caseStudyPreviewsSlider.getTranslate();
    caseStudyPreviewsSlider.setTranslate(currentX);

    $(caseStudyPreviewsSliderSelector).on('mouseleave', () => {
      // make all positve
      let tmpToX = toX < 0 ? toX * -1 : toX;
      let tmpFromX = fromX < 0 ? fromX * -1 : fromX;
      let tmpCurrentX = currentX < 0 ? currentX * -1 : currentX;

      // unleashing physics 101 skills
      let distance = tmpToX - tmpFromX;
      let progress = tmpCurrentX - tmpFromX;
      let distanceLeft = distance - progress;
      let speed = CASE_STUDY_SLIDER_SPEED * (distanceLeft / distance);

      caseStudyPreviewsSlider.translateTo(toX, speed);
    });
  });

  /**
   * Client logo slider
   */
  const CLIENT_LOGOS_SLIDER_SPEED = 7000;
  const clientLogoSlider = new Swiper('.client-logos', {
    loop: true,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    freeMode: true,
    slidesPerView: 'auto',
    speed: CLIENT_LOGOS_SLIDER_SPEED,
    grabCursor: true,
    mousewheel: false,
    pagination: false,
    navigation: false,
    modules: [Autoplay, FreeMode],
  });

  /**
   * Slider parallax
   */
  const sliderImages = document.querySelectorAll('.hero__image > img');
  new simpleParallax(sliderImages);

  /**
   * Mobile nav
   */
  $('.navbar-burger').on('click', () => {
    $('.mobile-nav').addClass('--active');
    $('body').addClass('overflow-hidden');
  });

  $('.mobile-nav__exit').on('click', () => {
    $('.mobile-nav').removeClass('--active');
    $('body').removeClass('overflow-hidden');
  });

  $('.mobile-nav.--active').on('click', e => {
    if (e.target === this) {
      $('.mobile-nav').removeClass('--active');
      $('body').removeClass('overflow-hidden');
    }
  });

  // Render maps on page load.
  $('.acf-map').each(function(){
    initMap( $(this) );
  });

});
